// Ported (slimmed) from V1's SpreadsheetView/config/accountStatusConfig.ts —
// the single source of truth for Account Status values and row tinting.
// Keep the hex values in sync with V1 until V1 is retired.

export interface AccountStatusOption {
  value: string;
  label: string;
  rowBgColor: string;
  rowTextColor: string;
  highlightColor: string;
  italic?: boolean;
  /** Tint the whole table row (every cell) in rowBgColor, not just the
   *  editors — reserved for statuses that should stand out from afar */
  fullRowTint?: boolean;
}

export const ACCOUNT_STATUS_OPTIONS: AccountStatusOption[] = [
  {
    value: '',
    label: 'No Status',
    rowBgColor: '#ffffff',
    rowTextColor: 'inherit',
    highlightColor: '#e5f0fe',
  },
  {
    value: 'Working',
    label: 'Working',
    rowBgColor: '#fefad5',
    rowTextColor: '#7b4610',
    highlightColor: '#fef4a6',
  },
  {
    value: 'Special Handling',
    label: 'Special Handling',
    rowBgColor: '#fee2bf',
    rowTextColor: '#8b3012',
    highlightColor: '#fdc88f',
  },
  {
    value: 'Ask My Accountant',
    label: 'Ask My Accountant',
    rowBgColor: '#feeaea',
    rowTextColor: '#8c1c1c',
    highlightColor: '#fed6d6',
    fullRowTint: true,
  },
  {
    value: 'Awaiting Receipts',
    label: 'Awaiting Receipts',
    rowBgColor: '#faeeff',
    rowTextColor: '#611e97',
    highlightColor: '#f4dcfe',
  },
  {
    value: 'Awaiting AM For Review',
    label: 'Awaiting AM For Review',
    rowBgColor: '#e7ecff',
    rowTextColor: '#342f92',
    highlightColor: '#d3dcfe',
  },
  {
    value: 'Awaiting Receipts & AM For Review',
    label: 'Awaiting Receipts & AM For Review',
    rowBgColor: '#ddfcfe',
    rowTextColor: '#15566c',
    highlightColor: '#baf6fd',
  },
  {
    value: '1099NEC Review',
    label: '1099NEC Review',
    rowBgColor: '#e5f0fe',
    rowTextColor: '#1e3d9c',
    highlightColor: '#cde2fe',
  },
  {
    value: 'Completed',
    label: 'Completed',
    rowBgColor: '#e8fbc2',
    rowTextColor: '#3a5a13',
    highlightColor: '#cbf580',
  },
  {
    value: 'Only Expenses Booked',
    label: 'Only Expenses Booked',
    rowBgColor: '#defcf5',
    rowTextColor: '#125651',
    highlightColor: '#b2f8ea',
  },
  {
    value: 'Account Closed',
    label: 'Account Closed',
    rowBgColor: '#e5e4e2',
    rowTextColor: '#4d4945',
    highlightColor: '#bfbab7',
    italic: true,
    fullRowTint: true,
  },
];

export function getAccountStatusOption(
  status: unknown
): AccountStatusOption | undefined {
  if (typeof status !== 'string') return undefined;
  const normalized = status.trim();
  if (!normalized || normalized.toLowerCase() === 'none') return undefined;
  return ACCOUNT_STATUS_OPTIONS.find(o => o.value === normalized);
}
